// removed by extract-text-webpack-plugin
module.exports = {"container":"container__KO_Pm","headerContainer":"headerContainer__FztDQ","submitButton":"submitButton__3UHPx","helperText":"helperText__1Gm2S","redirect__wrapper":"redirect__wrapper__94mEp","loader":"loader__oHfcM","redirect__text":"redirect__text__3hXAt","timer":"timer__IWwhI","buttonWrapper":"buttonWrapper__WlDlI","goBackButton":"goBackButton__2COgO"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/modals/errorBlockTransactionModal/style.css
// module id = Wk37
// module chunks = 307